import { useEffect } from "react";
import { Seo } from "@/components/Seo";
import { MaskedLines } from "@/components/Motion";
import { CtaLink } from "@/components/CtaLink";

export default function NotFound() {
  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex";
    document.head.appendChild(m);
    return () => m.remove();
  }, []);

  return (
    <section className="on-dark relative overflow-hidden bg-navy text-white" data-testid="not-found-page">
      <Seo title="Page Not Found" description="The page you were looking for could not be found." path="/404" />
      <div className="shell relative flex min-h-[78vh] flex-col justify-center py-24">
        <p aria-hidden="true" className="text-outline pointer-events-none absolute -right-4 bottom-0 select-none font-display text-[42vw] font-extrabold leading-none tracking-[-0.08em] text-white/15 lg:text-[30rem]">404</p>
        <p className="eyebrow text-lime">Error 404</p>
        <MaskedLines as="h1" onMount className="relative mt-6 font-display text-5xl font-extrabold leading-[1] tracking-[-0.045em] sm:text-7xl" lines={[{ content: "This page is" }, { content: "off the grid.", className: "text-lime" }]} />
        <p className="relative mt-8 max-w-md text-lg text-white/80">The page you’re looking for doesn’t exist or has moved. Let’s get you back on track.</p>
        <div className="relative mt-10 flex flex-wrap gap-3">
          <CtaLink to="/" variant="lime" testid="not-found-home-button">Back to Home</CtaLink>
          <CtaLink to="/portfolio" variant="ghostDark" testid="not-found-portfolio-button">View Portfolio</CtaLink>
        </div>
      </div>
    </section>
  );
}
